import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  titles: {
    draft: 'Your order (cost per month)',
    main: 'Your subscription',
    billing_settings: 'Billing settings',
  },
  form: {
    billing_mode: {
      label: 'Billing mode',
    },
    has_trial: {
      label: 'Add free trial days',
    },
    trial_days: {
      label: 'How many trial days should be there?',
      placeholder: '21',
      validation: {
        required: 'Trial days is required',
        min: '{{value}} is the minimal value for the trial days',
        max: '{{value}} is the maximal value for the trial days',
      },
    },
  },
  fields: {
    created_at: 'Created on <strong>{{date}}</strong> by <strong>{{manager}}</strong>',
    updated_at: 'Last updated on <strong>{{date}}</strong> by <strong>{{manager}}</strong>',
    trial_ends_at: 'On trial until <strong>{{date}}</strong>',
    trial_days: '{{trialDays}} days trial starts at the launch date, you will be charged when trial is over',
    resumable_until: 'Resumable until <strong>{{date}}</strong>',
    ended_at: 'Ended at <strong>{{date}}</strong>',
    next_bill_at: 'Next bill at <strong>{{date}}</strong>',
    product: 'Product',
    quantity: 'Quantity',
    price: 'Net Price',
    tax: 'Tax',
    amount: 'Amount',
    net: 'Net',
    tax_percentage: 'Tax {{rate}}%',
    total: 'Total charge per month',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Charge from payment method',
    [BillingMode.InternalInvoicing]: 'Charge from sales',
  },
  labels: {
    included: 'included',
    sales_based_discount:
      'There is an item in the basket with varying price, actual price will be calculated upon subscription creation/update based on last month sales metrics',
  },
  buttons: {
    edit: 'Edit',
    cancel: 'Cancel',
    resume: 'Resume',
  },
  modals: {
    cancel_subscription: {
      title: 'Cancel {{company}} subscription?',
      description:
        'This will cancel the selected subscription, including <strong>{{products}}</strong> (<strong>{{total}} total amount</strong>). The subscription stays active and can be resumed until <strong>{{endsAt}}</strong>. If it is not resumed by then, a new subscription has to be created.',
    },
    resume_subscription: {
      title: 'Resume {{company}} subscription?',
      description:
        'This will resume the selected subscription, including <strong>{{products}}</strong>. The restaurant is charged <strong>{{total}}</strong> every month, next on <strong>{{nextBillingDate}}</strong>.',
      description_prorated:
        'This will resume the selected subscription, including <strong>{{products}}</strong>. The first charge on <strong>{{nextBillingDate}}</strong> is prorated up to the 5th. From then on the restaurant is charged <strong>{{total}}</strong> on the 5th of each month.',
    },
  },
  toasts: {
    cancel_subscription:
      'If you want to cancel your subscription, please reach out via call or email to your {{provider}} contact person. Your contact will cancel the subscription for you immediately.',
    failed_to_cancel_subscription:
      'Something went wrong with cancelling the subscription. Please contact the tech support',
    resume_subscription:
      'If you want to resume your subscription, please reach out via call or email to your {{provider}} contact person. Your contact will resume the subscription for you immediately.',
    failed_to_resume_subscription:
      'Something went wrong with resuming the subscription. Please contact the tech support',
  },
};
